import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes, { any } from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';

import styles from './nextAvailable.scss';
import DraggableMatch from './DraggableMatch';
import { MatchStatusTypes } from '../../../utils/nextAvailable';
import { sportTypeIds } from '../../../utils/eventConstants';

const DroppableCourt = (props) => {
    const {
        eventId,
        sportTypeId,
        className,
        court,
        playersDictByMemberId,
        teamsDict,
        eventSchedule,
        onPostScoreClick,
    } = props;

    const nextAvailable = useSelector(({ nextAvailable }) => nextAvailable);
    const matchInCourt = nextAvailable.onCourtMatches?.find((match) => {
        return match.courtId === court.id;
    });

    return (
        <Droppable
            droppableId={court.id}
            isDropDisabled={!!matchInCourt}
        >
            {(provided) => (
                <div
                    className={`${styles.droppableCourt} ${className}`}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                >
                    <div className={styles.courtName} data-testid={`next-available.court-${court.id}.name`}>
                        {court.name}
                    </div>
                    <div className={styles.droppableMatchContainer} data-testid={`next-available.court-${court.id}.match-container`}>
                        {matchInCourt && (
                            <DraggableMatch
                                eventId={eventId}
                                sportTypeId={sportTypeId}
                                match={matchInCourt}
                                index={0}
                                isScheduled
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                eventSchedule={eventSchedule}
                                onPostScoreClick={onPostScoreClick}
                                statusType={MatchStatusTypes.ON_COURT}
                                data-testid={`next-available.court-${court.id}.match-${matchInCourt.id}`}
                            />
                        )}
                    </div>
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
};

DroppableCourt.propTypes = {
    className: PropTypes.string,
    court: PropTypes.objectOf(any).isRequired,
    playersDictByMemberId: PropTypes.objectOf(PropTypes.any).isRequired,
    teamsDict: PropTypes.objectOf(PropTypes.any).isRequired,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    eventSchedule: PropTypes.objectOf(PropTypes.any).isRequired,
    sportTypeId: PropTypes.number,
    onPostScoreClick: PropTypes.func.isRequired,
};

DroppableCourt.defaultProps = {
    className: '',
    sportTypeId: sportTypeIds.TENNIS,
};

export default DroppableCourt;
